// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';
// import invitation_Example from 'Assets/invitation-example.png';
import invitation_Example2 from './../../assets/invitation-example-2.png';
import invitation_ExampleError from './../../assets/invitation-tenant-error.png';
// import invitation_Example3 from 'Assets/invitation-example-3.png';
import CommonLayout from './../../components/CommonLayout';
// import authChangeConstants from 'Constants/authChangeConstants';

import Styles from './authModelInvite.module.scss';

export default function AuthModelInvite() {
    const { t } = useTranslation(['translation', 'faqTranslation']);
    return <AuthInvite pageTitle={t('auth_invitation_heading')} authText={t('auth_invitation_text')} />;
}

export function AuthInvite({ pageTitle, authText }: { pageTitle: string, authText: any }) {
    return (
        <section>
            <div className={Styles.authInvite}>
                <CommonLayout pageTitle={[pageTitle]}>
                    <div className={Styles.bodyContainer}>
                        <div className={Styles.title}>{authText}</div>
                        <br />
                        {/* <div className={Styles.bodyContainer}>
                            1. User will receive an email from invites@microsoft.com as shown below:
                            <img src={invitation_Example} alt="invitation" className={Styles.imageContainer} /><br />
                            2. After the clicking of the accept invitation. This page will appear, click on the accept button.<br />
                            <img src={invitation_Example2} alt="invitation" className={Styles.imageContainer} /><br />
                            <div className={Styles.title}>After Cutover</div>
                            1. Clear the cookies based on your browser. Here are the steps for most common browsers given below.<br />
                            <ul>
                                <li><a href={authChangeConstants.edgeCacheClearUrl} target="_blank" rel="noreferrer noopener"> Edge </a></li>
                                <li><a href={authChangeConstants.firefoxCacheClearUrl} target="_blank" rel="noreferrer noopener"> Firefox </a></li>
                                <li><a href={authChangeConstants.chromeCacheClearUrl} target="_blank" rel="noreferrer noopener"> Chrome </a></li>
                            </ul>
                            2. Close the browser.<br />
                            3. Open the new browser window and browse the Robo and login with appropriate account and fist time user has to accept this also.<br />
                            <img src={invitation_Example3} alt="invitation" className={Styles.imageContainer} /><br />
                        </div> */}
                        <div className={Styles.bodyContainer}>
                            <div>
                                <h1>Scenarios for ROBO user login post authentication model change</h1>
                                <h2>Overview</h2>
                                <p>
                                    This document outlines four potential scenarios that ROBO users may face when attempting to log in
                                     to the ROBO tool following a revision of the authentication model. Each scenario addresses a distinct
                                      user experience contingent on their interaction with the email invitation sent to them.
                                </p>
                                <h2>Scenario 1: User has accepted the invite sent via email</h2>
                                <p>
                                    In this scenario, the user has received and successfully accepted the email invitation.
                                    Consequently, they should be able to log in to the ROBO tool without encountering any issues.
                                </p>
                                <h4>Expected Outcome:</h4>
                                <ul>
                                    <li>The user navigates to the ROBO login page.</li>
                                    <li>The user inputs their credentials.</li>
                                    <li>The user is successfully authenticated and gains access to the ROBO tool.</li>
                                </ul>
                                <h2>Scenario 2: User has not accepted the invite sent over email</h2>
                                <p>
                                    In this scenario, the user has received the invitation but has not taken any action to accept it.
                                </p>
                                <h4>Expected Outcome:</h4>
                                <ul>
                                    <li>The user navigates to the ROBO login page.</li>
                                    <li>The user inputs their credentials.</li>
                                    <li>The user is prompted to accept the permission requested.</li>
                                    <img src={invitation_Example2} alt="invitation" className={Styles.imageContainer} /><br />
                                    <li>The user is successfully authenticated and gains access to the ROBO tool.</li>
                                </ul>
                                <h2>Scenario 3: User did not receive the invite via email</h2>
                                <p>
                                    In this case, the user asserts that they did not receive the email invitation.
                                </p>
                                <h4>Expected Outcome:</h4>
                                <ul>
                                    <li>The user navigates to the ROBO login page.</li>
                                    <li>The user inputs their credentials.</li>
                                    <li>The user receives an error message indicating that their account does not exist in Microsoft tenant.</li>
                                    <img src={invitation_ExampleError} alt="invitation" className={Styles.imageContainer} /><br />
                                    <li>The user should contact Microsoft support team by joining the hyper care bridge or raise the support ticket,
                                        to request a new invitation.</li>
                                </ul>
                                <h2>Scenario 4: User has accepted the invite but encounters an error during login attempt</h2>
                                <p>
                                    In this instance, the user has accepted the invitation but encounters an error message when attempting to log in
                                     to the ROBO tool.
                                </p>
                                <h4>Expected Outcome:</h4>
                                <ul>
                                    <li>The user navigates to the ROBO login page.</li>
                                    <li>The user inputs their credentials.</li>
                                    <li>The user receives an error message.</li>
                                    <li>The user needs to clear the browser cache by following the steps for their browser.</li>
                                    <li>The user closes the browser and opens a new browser to log in to ROBO.</li>
                                    <li>In case the error persists, the user should contact Microsoft support team by joining the hyper care bridge
                                        or raise the support ticket.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </CommonLayout>
            </div>
        </section>
    );
}

